<template>
  <section>
    <div v-if="!isMobile">
        <app-nav-app/>
    </div>
    <div v-if="isMobile">
        <app-mobile-nav-app/>
    </div>
    <div id="hero-body-accueil" class="hero-body">
      <div id="container-accueil" class="container">
        <div >
          <h3 class="is-size-2 colorH3">Bienvenue sur le portail annonceur</h3>
          <p>Ce portail permet à nos clients afficheurs d'envoyer leurs propositions
            commerciales de manière dématérialisée.</p>
            <div id="btnDecouvrirAffixe">
                <div><a>Découvrir Affixe 2.0</a></div>
            </div>
            <div id="zonePetitLogo">
                <div id="petitLogo"><img src="/static/img/Groupe_2194.svg"/></div>
                <div id="petitLogo"><img src="/static/img/Logo_Quadra@2x.png"/></div>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import navApp from './composants/navApp';
import mobileNavApp from './ismobile/composants/navApp';

export default {
  name: 'Accueil',
  components: {
    appNavApp: navApp,
    appMobileNavApp: mobileNavApp,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/Accueil.vue